import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Modal from './Modals/Modal';
import Button from '@material-ui/core/Button';
import { withNamespaces } from 'react-i18next';
import classnames from 'classnames';

import combineStyles from '../../utils/combineStyles';
import ButtonStyles from '../../styles/button';
import TypographyStyles from '../../styles/typography';


const styles = theme => ({
  formTitle: {
    fontWeight: 'bold !important',
    marginBottom: `${theme.spacing.unit * 2}px !important`
  },
  modalFooter: {
    marginTop: `${theme.spacing.unit * 4}px !important`
  }
});

export class NotificationModal extends Component {
  render() {
    const { classes, open, onClose, viewDetails, notification, t } = this.props;
    return (
      <Modal
        open={open}
        onClose={onClose}

        classes={{
          footer: classes.modalFooter
        }}
        body={
          <Fragment>
          <p className={classnames(classes.formTitle, classes.headline6)}>{`${
            notification.title && notification.title.toUpperCase()
              } ${notification.headerMessage && notification.headerMessage.toUpperCase()}`}</p>
          
            {
              // TODO: This is the original code to format the message.  When the backend is reworked to send richer messages, we can reuse this.
              /*<p className={classnames(classes.formTitle, classes.headline6)}>{`${
                notification.title
              } ${notification.headerMessage}`}</p>
              <p className={classes.body1Light}>{`"${
                notification.content
              }"`}</p>*/
              <div>
                <p className={classes.subtitle2}>{`${notification.createdAt}`}</p>
                <p className={classes.body1}>{`${notification.headerMessage} ${notification.content}`}</p>

              </div>

              
              
            }
          </Fragment>
        }
        footer={
          <Fragment>
            {/* <Button
              color={'primary'}
              className={classes.textButton}
              onClick={viewDetails}
            >
              {t('View Details')}
            </Button> */}
            <Button
              color={'primary'}
              className={classes.textButton}
              onClick={onClose}
            >
              {t('OK')}
            </Button>
          </Fragment>
        }
      />
    );
  }
}
const translatedNotificationModal = withNamespaces()(NotificationModal);
export default withStyles(
  combineStyles(styles, ButtonStyles, TypographyStyles)
)(translatedNotificationModal);
